import loadTranslations from './loadTranslations';
import loadDexfSettings from './loadDexfSettings';
import loadCmsData from './loadCmsData';
import loadProductMenu from './loadProductMenu';
import loadProducts from '../../services/products/loadProducts';
import loadImages from '../../services/products/loadImages';
import { init as initAnalytics } from '../../services/statistics/analytics';
import { INIT_ERROR, INIT_DONE } from '../actionConstants';
import { findPAC } from '../tac/tacActions.js';
import { ActionCreator, Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootAction, Action as OwnAction } from '../../generalTypes';
import { State } from '../StateTypes';
import setUpScreensaverTimers from './SetUpScreensaverTimers';
import { thunkBuildYMALs } from '../ymal/ymalThunks';
import { thunkSetupDerivedDefaultState } from './thunkSetupDerivedDefaultState';
import { thunkInitView } from '../navigation/navigationThunks';
import { selectCurrentView } from '../navigation/navigationSelectors';
import { initializeDexfABTests } from '../../util/abTestUtility';

const inits = [loadImages, loadCmsData];

export const init = (): ActionCreator<
  ThunkAction<Action, State, void, any>
> => {
  return (dispatch, getState) =>
    dispatch(loadDexfSettings())
      .then(() => dispatch(loadTranslations()))
      .then(() => initializeDexfABTests())
      .then(() => initAnalytics())
      .then(() => loadProducts())
      .then(() => dispatch(loadProductMenu()))
      .then(() => Promise.all(inits.map(initAction => dispatch(initAction()))))
      .then(() => dispatch(thunkSetupDerivedDefaultState()))
      .then(() => dispatch(findPAC()))
      .then(() => dispatch(thunkBuildYMALs()))
      .then(() => setUpScreensaverTimers())
      .then(() => dispatch(thunkInitView(selectCurrentView(getState()))))
      .then(() => dispatch(initDone()))
      .catch((error: string) => dispatch(initError(error)));
};

const initError = (errorMsg: string): OwnAction<string> => {
  console.error(errorMsg);

  return {
    type: INIT_ERROR,
    payload: errorMsg,
  };
};

const initDone = (): RootAction => ({
  type: INIT_DONE,
});
